// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2VXt0","left":"InfoRow_left__1kuSK"};